import React, { useState } from "react";
import {
  Drawer,
  Descriptions,
  Tag,
  Timeline,
  Input,
  Button,
  Empty,
  Divider,
} from "antd";
import {
  SendOutlined,
  UserOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { Candidate } from "../types";

const { TextArea } = Input;

interface CandidateDrawerProps {
  candidate: Candidate | null;
  isOpen: boolean;
  onClose: () => void;
  onAddNote: (candidateId: string, text: string) => void;
}

export const CandidateDrawer: React.FC<CandidateDrawerProps> = ({
  candidate,
  isOpen,
  onClose,
  onAddNote,
}) => {
  const [noteText, setNoteText] = useState("");

  if (!candidate) return null;

  const handleAddNote = () => {
    if (!noteText.trim()) return;
    onAddNote(candidate.id, noteText);
    setNoteText("");
  };

  return (
    <Drawer
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <UserOutlined />
          <span>{candidate.name}</span>
          <Tag color="blue">{candidate.role}</Tag>
        </div>
      }
      width={450}
      placement="right"
      onClose={onClose}
      open={isOpen}
    >
      {/* 1. Candidate Details */}
      <Descriptions
        title="Candidate Info"
        layout="vertical"
        column={1}
        size="small"
      >
        <Descriptions.Item label="Email">{candidate.email}</Descriptions.Item>
        <Descriptions.Item label="Applied Date">
          {candidate.appliedDate}
        </Descriptions.Item>
        <Descriptions.Item label="Current Status">
          <Tag>{candidate.status}</Tag>
        </Descriptions.Item>
      </Descriptions>

      <Divider />

      {/* 2. Notes Section */}
      <h3>Notes & Activity</h3>

      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        <TextArea
          rows={2}
          placeholder="Add interview notes or feedback..."
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
        />
        <Button
          type="primary"
          icon={<SendOutlined />}
          style={{ height: "auto" }}
          onClick={handleAddNote}
        />
      </div>

      {candidate.notes.length === 0 ? (
        <Empty
          description="No notes yet"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      ) : (
        <Timeline
          mode="left"
          items={candidate.notes.map((note) => ({
            label: (
              <span style={{ fontSize: "12px", color: "#999" }}>
                {note.createdAt}
              </span>
            ),
            children: (
              <span style={{ whiteSpace: "pre-wrap" }}>{note.text}</span>
            ),
            dot: <ClockCircleOutlined style={{ fontSize: "16px" }} />,
          }))}
        />
      )}
    </Drawer>
  );
};
